import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { getContentAuditStatus } from '@pepper/utils/src/api/assignments/assignments'

interface Parameter {
  data: {
    itemId: string
  }
  options?: Pick<UseQueryOptions, 'enabled'>
}

async function getAuditStatus(data: Parameter['data']) {
  const response = await getContentAuditStatus({ assignmentId: data.itemId })

  if (response.status !== 'ok') throw new Error(response.error)
  return response.data
}

export function useGetMarketplaceAuditStatus({ data, options }: Parameter) {
  return useQuery({
    queryKey: ['content-audit', 'status', data.itemId],
    queryFn: () => getAuditStatus(data),
    ...options,
  })
}
